import { privateClient } from "./client";

const sendClientInfo = (data, msisdn) =>
  privateClient.post("/fraud-analysis", { browserInfo: data, msisdn });

export { sendClientInfo };
